// extracted by mini-css-extract-plugin
export var divider = "_fu-7";
export var itemsToggle = "_fu-8";
export var mergeModal = "_fu-1";
export var optionCard = "_fu-4";
export var radioGroup = "_fu-6";
export var radioOption = "_fu-0";
export var selected = "_fu-5";
export var shipmentOptions = "_fu-2";
export var tableOptions = "_fu-3";